
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <div v-if="form.filters.analitico">
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.greIdAnalitico"
                            label="GRE"
                            dense
                            outlined
                            item-text="nome"
                            item-value="codigo"
                            :items="form.lists.listaGerenciasRegionais"
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        label="Formação"	
                        v-model="form.filters.formacaoAnalitico"
                        outlined
                        dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-autocomplete
                        v-model="form.filters.statusFormacaoIdAnalitico"
                        label="Status da Formação"
                        dense
                        outlined
                        item-text="situacao"
                        item-value="id"
                        :items="form.lists.listaStatusFormacao"
                      />
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioAnalitico"
                        removeIcon
                        outlined
                        dense
                  ></sigfoco-date-picker>
                  <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFimAnalitico"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                  ></sigfoco-date-picker>
                  <sigfoco-switch-button
                    :cols="2"
                    v-model="form.filters.analitico"
                    label="Tipo de Relatório"
                    labelChecked="Analítico"
                    labelUnchecked="Sintético"
                ></sigfoco-switch-button>
                </v-row>
            </div>
            <div v-else>
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.greIdSintetico"
                            label="GRE"
                            dense
                            outlined
                            item-text="nome"
                            item-value="codigo"
                            :items="form.lists.listaGerenciasRegionais"
                        />
                    </v-col>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioSintetico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        v-model="form.filters.dataFimSintetico"
                        label="Data Final"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                </v-row>
            </div>
            <div class="text-center">
                <v-col cols="12">
                    <sigfoco-tooltip
                        text="Buscar"
                        icon="mdi-magnify"
                        @click="buscarRelatorios"
                    ></sigfoco-tooltip>
                    <sigfoco-tooltip
                        text="Limpar"
                        icon="mdi-eraser"
                        @click="resetForm"
                    ></sigfoco-tooltip>
                </v-col>
            </div>
        </v-form>
        <v-data-table
          v-if="form.mostrarAnalitico"
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorioAnalitico"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.gre`]="{ item }">
            {{ item.gre }}
          </template>
          <template v-slot:[`item.escola`]="{ item }">
            {{ item.escola }}
          </template>
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.cargaHoraria`]="{ item }">
            {{ item.cargaHoraria }}
          </template>
        </v-data-table>
        <v-data-table
            v-else
            class="mt-5 printable"
            :headers="getFilteredHeader(headersSintetico)"
            :items="form.lists.listRelatorioSintetico"
            :items-per-page="form.itemsPerPage"
            :footer-props="$footerProps"
        >
            <template v-slot:[`item.gre`]="{ item }">
            {{ item.gre }}
            </template>
            <template v-slot:[`item.quantidadeFormacoes`]="{ item }">
            {{ item.quantidadeFormacoes }}
            </template>
            <template v-slot:[`item.quantidadeDeParticipantesPrevista`]="{ item }">
            {{ item.quantidadeDeParticipantesPrevista }}
            </template>
            <template v-slot:[`item.quantidadeDeParticipantesPresentes`]="{ item }">
            {{ item.quantidadeDeParticipantesPresentes }}
            </template>
            <template v-slot:[`item.quantidadeDeParticipantesAusentes`]="{ item }">
            {{ item.quantidadeDeParticipantesAusentes }}
            </template>

        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorioAnalitico.length > 0 || form.lists.listRelatorioSintetico.length > 0"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
import RelatorioSinteticoAnalitico from "services/relatorios-sintetico-analiticos/solicitacao-formacao.service";
import FormacaoService from "~/services/manter-formacao.service";
export default {
    name: "RelatorioSolicitacaoFormacaoPorGre",
    mixins: [pageLoadingMixin, RelatorioSinteticoAnalitico, FormacaoService],
    data: () => ({
    onReport: false,
    expanded: [],
    form: {
        filters: {
            analitico: true,
            // analitico
            greIdAnalitico: null,
            formacaoAnalitico: null,
            statusFormacaoIdAnalitico: null,
            dataInicioAnalitico: null,
            dataFimAnalitico: null,
            // sintetico
            greIdSintetico: null,
            dataInicioSintetico: null,
            dataFimSintetico: null,
        },
        lists: {
            listRelatorios: [],
            listRelatorioAnalitico: [],
            listRelatorioSintetico: [],
            listaGerenciasRegionais: [],
            listaStatusFormacao: [],
        },
        itemsPerPage: 10,
        mostrarAnalitico: true,
        },
        situacoes: [
          "Aguardando Aprovação",
          "Aguardando Consolidação",
          "Consolidada",
          "Pendente de Ajuste - Aprovação",
          "Reprovada - Aprovação",
          "Reprovada - Aprovação",
          "Reprovada - Consolidação",
          "Aguardando Aprovação - Reagendamento",
          "Aguardando Consolidação - Reagendamento",
          "Concluída",
        ],
        headersAnalitico: [
            { text: "GRE", align: "center", value: "gre" },
            { text: "Formação", align: "center", value: "formacao" },
            { text: "Status da Formação", align: "center", value: "statusFormacao" },
        ],
        headersSintetico: [
            { text: "GRE", align: "center", value: "gre" },
            { text: "Quantidade de Formações", align: "center", value: "quantidadeFormacoes" },
            { text: "Quantidade Prevista de Participantes", align: "center", value: "quantidadeDeParticipantesPrevista" },
            { text: "Quantidade de Participantes Presentes", align: "center", value: "quantidadeDeParticipantesPresentes" },
            { text: "Quantidade de Participantes Ausentes", align: "center", value: "quantidadeDeParticipantesAusentes" },
        ],
    }),
    watch: {
        "form.filters.analitico"(novoValor) {
            this.form.mostrarAnalitico = novoValor;
            this.resetForm();
            
        }
    },

    computed: {
        isAnalitico() {
            return this.form.filters.analitico;
        },
    },
    methods: {
        getFilteredHeader(headers) {
            return headers.filter(header => {
              if (header.onlyView) return !this.onReport;
              if (header.onlyReport) return this.onReport;
              return true;
            });
        },
        buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            const preparedRequest = this.prepararRequisicao();
                const buscarRelatorio = (request) => {
                    return this.$obterRelatorioSolicitacaoFormacaoPorGre(request);
                };
                buscarRelatorio(this.$montarParamsFilters(preparedRequest)).then(({ data }) => {
                    this.form.mostrarAnalitico = this.isAnalitico;
                    this.isAnalitico
                        ? this.form.lists.listRelatorioAnalitico = data.relatorio?.listaAnalitico
                        : this.form.lists.listRelatorioSintetico = data.relatorio?.listaSintetico;
                }
            );
        },
        validarDatas() {
            const { dataInicioAnalitico, dataFimAnalitico, dataInicioSintetico, dataFimSintetico } = this.form.filters;
            const msgData = "A Data Início precisa ser anterior à Data Final";
            if (dataInicioAnalitico && dataFimAnalitico) {
                if (new Date(dataInicioAnalitico) > new Date(dataFimAnalitico)) {
                    this.$notifyWarning(msgData);
                    return false;
                }
            }
            if (dataInicioSintetico && dataFimSintetico) {
                if (new Date(dataInicioSintetico) > new Date(dataFimSintetico)) {
                    this.$notifyWarning(msgData);
                    return false;
                }
            }

            return true;
        },
        async baixarCSVRelatorio() { 
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
                const { data } = await (this.$obterRelatorioCSVSolicitacaoFormacaoPorGre(this.$montarParamsFilters(preparedRequest))
                );
                this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeDeFormaçãoPorGre`);
                this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
                this.hidePageLoading();
            }
        },

        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
                const { data } = await (this.$obterRelatorioPDFSolicitacaoFormacaoPorGre(this.$montarParamsFilters(preparedRequest)));

                const url = URL.createObjectURL(data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "SIGFOCO.RelatórioDeFormaçãoPorGre.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
                this.hidePageLoading();
            }
        },

        prepararRequisicao() {
            if (this.isAnalitico) {
                return {
                    greCodigo: this.form.filters.greIdAnalitico,
                    formacao: this.form.filters.formacaoAnalitico,
                    statusFormacaoId: this.form.filters.statusFormacaoIdAnalitico,
                    dataInicio: this.form.filters.dataInicioAnalitico,
                    dataFim: this.form.filters.dataFimAnalitico,
                    isAnalitico: this.isAnalitico,
                };
            } else {
                return {
                    greCodigo: this.form.filters.greIdSintetico,
                    dataInicio: this.form.filters.dataInicioSintetico,
                    dataFim: this.form.filters.dataFimSintetico,
                    isAnalitico: this.isAnalitico,
                };
            }
        },
        resetForm() {
            this.form.filters.dataInicioAnalitico = null;
            this.form.filters.dataFimAnalitico = null;
            this.form.filters.dataInicioSintetico = null;
            this.form.filters.dataFimSintetico = null;
            this.form.filters.statusFormacaoIdAnalitico = null

            this.$nextTick(() => {
                this.$set(this.form.filters, 'dataInicioAnalitico', null);
                this.$set(this.form.filters, 'dataFimAnalitico', null);
                this.$set(this.form.filters, 'dataInicioSintetico', null);
                this.$set(this.form.filters, 'dataFimSintetico', null);
            });
            this.form.filters.formacaoAnalitico = null;
            this.form.filters.greIdAnalitico = null;
            this.form.filters.greIdSintetico = null;
            this.form.filters.escolaIdSintetico = null;
            this.form.lists.listRelatorioAnalitico = [];
            this.form.lists.listRelatorioSintetico = [];
        },
    },
    mounted() {
        this.$obterListaGerenciasRegionais().then(({ data }) => {
            this.form.lists.listaGerenciasRegionais = data.lista;
        });
        this.$buscarStatusFormacao().then(({ data }) => {
            this.form.lists.listaStatusFormacao = data.lista.filter(l => this.situacoes.includes(l.situacao));
        });
    }
};
</script>